module.exports = __webpack_public_path__ + "static/img/img2.bd5e71b4.png";